import React from 'react';

import { ErrorBoundaryLayout } from '../layouts/ErrorBoundaryLayout/ErrorBoundaryLayout';

export const UnauthorizedPage = () => (
  <div data-test="unauthorized-page">
    <ErrorBoundaryLayout errorMessage="You are not authorized to view this page" />
  </div>
);
